export default "__VITE_ASSET__B8u94c16__ 120w, __VITE_ASSET__B0OdwXqd__ 240w, __VITE_ASSET__Ama0I5Oq__ 480w, __VITE_ASSET__CZEwngnp__ 512w";